"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAddress = void 0;
const ethers_1 = require("ethers");
function isAddress(value) {
    let result = false;
    if (value && value !== ethers_1.constants.AddressZero) {
        try {
            const address = ethers_1.utils.getAddress(value);
            if (address) {
                result = address === value;
            }
        }
        catch (err) {
            result = false;
        }
    }
    else if (value === ethers_1.constants.AddressZero) {
        result = true;
    }
    return result;
}
exports.isAddress = isAddress;
